import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ProgressBar from "common/ProgressBar";
import { ANSWER_SOURCE, QUESTION_FLOW } from "lib/constants";
import { staticURL } from "lib/img";
import { filterQuestions } from "redux/questions/selectors";

import Questions from "./Questions";
import Suggestions from "./Onboard/Suggestions";

const mapStateToProps = ({ answerCount, questions }) => ({
    answerCount,
    currentQuestion: questions.current,
    questionCount: answerCount + filterQuestions({ questions }).length,
    notLooking: questions.filters.preferences === false,
});

class CandidateOnboard extends React.PureComponent {
    static propTypes = {
        answerCount: PropTypes.number.isRequired,
        currentQuestion: PropTypes.number,
        notLooking: PropTypes.bool.isRequired,
        questionCount: PropTypes.number.isRequired,
    };

    static defaultProps = {
        currentQuestion: null,
    };

    state = {
        progress: 1,
        maxProgress: this.props.questionCount,
    };

    UNSAFE_componentWillReceiveProps({ answerCount, questionCount }) {
        // eslint-disable-line
        // Normally we could just use the props that are passed in, but because the filtering
        // mechanisms can be set in the redux state before the filtering should really be
        // happening, you'd get a weird scenario where the bar would increase before the next
        // button is hit. So here we are.
        if (answerCount !== this.props.answerCount) {
            this.setState({
                progress: answerCount + 1,
                maxProgress: questionCount,
            });
        }
    }

    renderNotLooking() {
        return (
            <div className="content onboard suggestions__root">
                <div className="suggestions__empty">
                    <img src={staticURL("illo-briefcase.svg")} alt="briefcase" />
                    <p>Thanks for answering our questions!</p>
                    <a href="/profile/" className="btn btn-large btn-primary">
                        Check out your profile
                    </a>
                </div>
            </div>
        );
    }

    render() {
        const { currentQuestion, questionCount, notLooking } = this.props;
        if (currentQuestion === null || questionCount === 0) {
            if (notLooking) {
                return this.renderNotLooking();
            }

            return <Suggestions />;
        }

        return (
            <div className="content content--center questions questions--onboard">
                <ProgressBar current={this.state.progress} max={this.state.maxProgress} />
                <Questions flow={QUESTION_FLOW.ONBOARD} source={ANSWER_SOURCE.ONBOARD} />
            </div>
        );
    }
}

export default connect(mapStateToProps)(CandidateOnboard);
